import {ProjectsListItemModel} from '../../models/projects-list-item.model';
import {MySortButtonStatesEnum} from '../../enums/my-sort-button-states.enum';
import {PriceApprovalStatusEnum} from '../../enums/price-approval-status.enum';
import {ProjectStatusEnum} from '../../enums/project-status.enum';


export class ProjectTablesBase {
    constructor(
    ) {
    }


    private getStatusProgress(status: any): number {

        switch (status) {
            case ProjectStatusEnum.DRAFT:
                return 1;

            case ProjectStatusEnum.REQUEST:
                return 2;

            case ProjectStatusEnum.IN_PROCESS:
                return 3;
            case ProjectStatusEnum.QUOTE_SENT:
                return 4;
            case ProjectStatusEnum.QUOTE_SENT_MANUALLY:
                return 4;
            case ProjectStatusEnum.PROJECT_WON:
                return 5;
            case ProjectStatusEnum.REJECTED:
                return 5;
            case ProjectStatusEnum.PROJECT_LOST:
                return 8;
            case ProjectStatusEnum.DELETED:
                return 0;
            default:
                return -1;

        }
    }

    public sortTableBySortingData(filteredProjects: Object[], sortingData: { property: string, sortOrder: MySortButtonStatesEnum }) {

        // console.log('sorting params:', sortingData);

        if (filteredProjects.length > 1) {

            switch (sortingData.property) {
                case 'status':
                    filteredProjects.sort((a: ProjectsListItemModel, b: ProjectsListItemModel) => {


                        // const textA = MyProjectStatusBarTranslateEnum[EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum[a[sortingData.property]])];
                        // const textB = MyProjectStatusBarTranslateEnum[EnumUtils.getKeyByValue(ProjectStatusEnum, ProjectStatusEnum[b[sortingData.property]])];


                        const statusProgressA = this.getStatusProgress(ProjectStatusEnum[a[sortingData.property]]);
                        const statusProgressB = this.getStatusProgress(ProjectStatusEnum[b[sortingData.property]]);

                        let result = (statusProgressA > statusProgressB) ? -1 :
                            (statusProgressA < statusProgressB) ? 1 : 0;

                        if (sortingData.sortOrder === MySortButtonStatesEnum.DESCENT) {
                            result *= -1;
                        }
                        return result;
                    });
                    return;

                case 'priceApprovalStatus':
                    filteredProjects.sort((a: ProjectsListItemModel, b: ProjectsListItemModel) => {

                        let result = (PriceApprovalStatusEnum[a[sortingData.property]] < PriceApprovalStatusEnum[b[sortingData.property]]) ? -1 :
                            (PriceApprovalStatusEnum[a[sortingData.property]] > PriceApprovalStatusEnum[b[sortingData.property]]) ? 1 : 0;

                        if (sortingData.sortOrder === MySortButtonStatesEnum.ASCENT) {
                            result *= -1;
                        }
                        return result;
                    });
                    return;


                case 'validityOfQuotation':
                    filteredProjects.sort((a: ProjectsListItemModel, b: ProjectsListItemModel) => {

                        const aValue = a[sortingData.property] + ' ';
                        const bValue = b[sortingData.property] + ' ';

                        let result = (aValue < bValue) ? -1 : (aValue > bValue) ? 1 : 0;

                        if (sortingData.sortOrder === MySortButtonStatesEnum.DESCENT) {
                            result *= -1;
                        }
                        return result;
                    });
                    return;


                default:
                    // console.log('default sorting...')
                    filteredProjects.sort((a: ProjectsListItemModel, b: ProjectsListItemModel) => {


                        let aSortValue = a[sortingData.property];
                        let bSortValue = b[sortingData.property];

                        if (aSortValue === null) {
                            aSortValue = '-';
                        }

                        if (bSortValue === null) {
                            bSortValue = '-';
                        }

                        let result = (aSortValue < bSortValue) ? -1 :
                            (aSortValue > bSortValue) ? 1 : 0;

                        if (sortingData.sortOrder === MySortButtonStatesEnum.ASCENT) {
                            result *= -1;
                        }


                        return result;
                    });
                    return;
            }
        }
    }
}
